const messages = {
    en: {
        alphanumeric: "Only alphanumeric characters are allowed.",
        missingValue: {
            checkbox: "This field is required.",
            radio: "Please select a value.",
            select: "Please select a value.",
            "select-multiple": "Please select at least one value.",
            default: "Please fill out this field.",
        },
        patternMismatch: {
            email: "Please enter a valid email address.",
            url: "Please enter a URL.",
            number: "Please enter a number",
            color: "Please match the following format: #rrggbb",
            date: "Please use the YYYY-MM-DD format",
            time: "Please use the 24-hour time format. Ex. 23:00",
            month: "Please use the YYYY-MM format",
            default: "Please match the requested format.",
        },
        outOfRange: {
            over: "Please select a value that is no more than {max}.",
            under: "Please select a value that is no less than {min}.",
        },
        wrongLength: {
            over:
                "Please shorten this text to no more than {maxLength} characters. " +
                "You are currently using {length} characters.",
            under:
                "Please lengthen this text to {minLength} characters or more. You are " +
                "currently using {length} characters.",
        },
        fallback: "There was an error with this field.",
    },
    ro: {
        alphanumeric: "Sunt permise doar caractere alfa-numerice",
        missingValue: {
            checkbox: "Acest câmp este obligatoriu.",
            radio: "Vă rugăm să selectați o valoare.",
            select: "Vă rugăm să selectați o valoare.",
            "select-multiple": "Vă rugăm să selectați cel puțin o valoare.",
            default: "Vă rugăm să completați acest câmp.",
        },
        patternMismatch: {
            email: "Vă rugăm să introduceți o adresă de email validă.",
            url: "Vă rugăm să introduceți o adresă URL.",
            number: "Vă rugăm să introduceți un număr.",
            color: "Vă rugăm să respectați formatul următor: #rrggbb",
            date: "Vă rugăm să utilizați formatul YYYY-MM-DD",
            time: "Vă rugăm să utilizați formatul de 24 de ore. Ex. 23:00",
            month: "Vă rugăm să utilizați formatul YYYY-MM",
            default: "Vă rugăm să respectați formatul cerut.",
        },
        outOfRange: {
            over: "Vă rugăm să selectați o valoare care să nu fie mai mare de {max}.",
            under: "Vă rugăm să selectați o valoare care să nu fie mai mică de {min}.",
        },
        wrongLength: {
            over:
                "Vă rugăm să scurtați acest text la cel mult {maxLength} caractere. " +
                "În prezent folosiți {length} caractere.",
            under:
                "Vă rugăm să lungiți acest text la cel puțin {minLength} caractere." +
                " În prezent folosiți {length} caractere.",
        },
        fallback: "A apărut o eroare cu acest câmp.",
    },
};

export default messages;
